<section class="wraper-sub">
  <div class="sales-agent-stats-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Sales Agent Stats</h1>
        <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection" *ngIf="salesData">
            <span>$ {{ salesData.total_sales_amount | number }}  </span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="salesData && salesData.total_sales_amount != '0'"></i>
          </p>

          <div class="year-selection-m sales-selection-m" *ngIf="salesData && salesData.total_sales_amount != '0'">
            <!-- Modal -->
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" style="max-width: 420px;" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel" *ngIf="salesData">Total: $ {{ salesData.total_sales_amount }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p sales-Stats-m" *ngIf="salesData">
                      <li class="sales-top-head">
                        <span class="top-span">Sale Type</span>
                        <span class="top-span">No.of Sales</span>
                        <span class="top-span">Amount</span>
                      </li>
                      <li>
                        <label>Valid</label>
                        <span>{{ salesData.valid_sales }}</span>
                        <span>$ {{ salesData.valid_sales_amount }}</span>
                      </li>
                      <li>
                        <label>Invalid</label>
                        <span>{{ salesData.in_valid_sales}}</span>
                        <span>$ {{ salesData.in_valid_sales_amount }}</span>

                      </li>
                      <li>
                        <label>Verified</label>
                        <span>{{ salesData.verified_sales}}</span>
                        <span>$ {{ salesData.verified_sales_amount }}</span>
                      </li>
                      <li>
                        <label>Unverified</label>
                        <span>{{ salesData.un_verified_sales}}</span>
                        <span>$ {{ salesData.un_verified_sales_amount }}</span>
                      </li>
                      <li class="overall-rating">
                        <label>Overall Rating: {{ salesData.total_rating }}</label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" (change)="rerender()" [(ngModel)]="searchParams.emailId" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
              </svg>

            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m multi-select">
              <ng-select
                [items]="agents"
                bindLabel="name"
                multiple="true"
                bindValue="id"
                placeholder="Select Agents"
                [(ngModel)]="searchParams.agent_id"
                [ngModelOptions]="{standalone: true}"
                [closeOnSelect]="false"
                [searchable]="true"
                [clearable]="true"
                (change)="selectAll()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                    <input [checked]="searchParams.agent_id.indexOf(item.id) > -1" type="checkbox">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="verification"
                bindLabel="name"
                bindValue="value"
                placeholder="Select Verified Sales"
                [(ngModel)]="searchParams.verification"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="validity"
                bindLabel="name"
                bindValue="value"
                placeholder="Select Valid Sales"
                [(ngModel)]="searchParams.validity"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>S#</th>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client info</th>
              <th>Price / No. of Pages</th>
              <th>Due Date</th>
              <th>Verification</th>
              <th>Valid/Invalid</th>
              <th>Q/A Feedback</th>
              <th>Comments</th>
            </tr>
          </thead>
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ paginatePage + (indx + 1) }}</td>
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>

                <td>
                  <p class="time-done" *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <p>{{ lead.name }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <p class="price-td" [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                  <p class="page-td">{{ lead.pages }} Pages</p>
                </td>
                <td>

                  <p *ngIf="lead.delivery_date == '0000-00-00 00:00:00'">-</p>
                  <ng-container *ngIf="lead.delivery_date != '0000-00-00 00:00:00'">
                    <p class="time-done">{{ lead.delivery_date | date }}</p>
                    <p class="time-done">{{ lead.delivery_date | date:'shortTime' }}</p>
                  </ng-container>
                  <p [ngClass]="{'time-elapsed': lead.invert, 'time-left': !lead.invert}" *ngIf="lead.delivery_date != '0000-00-00 00:00' && lead.delivery_date != '0000-00-00 00:00:00'">{{ lead.due_date }}</p>
                  <ng-template #showDash>-</ng-template>
                </td>
                <td>
                  <a href="javascript:;" [ngClass]="{'inactive': lead.verified_sales == '0'}">
                    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.15584 12.4036C6.6111 11.5714 7.1148 10.7667 7.66435 9.99343C9.52238 7.43058 11.8086 5.30168 14.3422 3.42453C16.0268 2.17128 17.8082 1.05343 19.6697 0.0814906C19.8724 -0.0243497 20.0161 -0.0372017 20.2113 0.103415C20.5956 0.380111 21.0026 0.623544 21.4286 0.897973C20.4611 1.55904 19.5291 2.27041 18.6362 3.02914C15.3332 5.86566 12.612 9.20114 10.2305 12.8262C8.93947 14.7748 7.78016 16.8074 6.7603 18.9105C6.69373 19.0496 6.62261 19.1509 6.45013 19.1978C5.5423 19.4457 4.64203 19.7103 3.74025 19.9734C3.56474 20.0241 3.46109 20.0218 3.44445 19.7897C3.26894 17.2601 2.53662 14.8674 1.62879 12.52C1.17326 11.3372 0.652473 10.1805 0.0688346 9.05523C-0.0355659 8.85414 -0.0446442 8.76947 0.208792 8.69387C1.10679 8.41868 1.99873 8.12157 2.88689 7.81539C3.09494 7.73979 3.20161 7.8101 3.33022 7.95828C4.48466 9.29391 5.43668 10.7916 6.15584 12.4036Z" fill="#00A5DC"/>
                    </svg>
                  </a>
                </td>
                <td>
                  <p class="roundedShape">
                    <span class="validBox" *ngIf="lead.valid_sales == '1'">Valid</span>
                    <span class="invalidBox" *ngIf="lead.valid_sales == '0'">Invalid</span>
                    <span class="noBox" *ngIf="lead.valid_sales == '2'">N/A</span>
                  </p>
                </td>
                <td>
                  <div class="pos-rel">
                    <a href="javascript:;" (click)="showComments(lead,indx,'QA-Comments')">
                      <div class="stars genralFeedback" *ngIf="qaLoader != lead.id">
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 1 , 'active-half': parseFloat(lead.rating) > 0 && parseFloat(lead.rating) < 1 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 2 , 'active-half': parseFloat(lead.rating) > 1 && parseFloat(lead.rating) < 2 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 3 , 'active-half': parseFloat(lead.rating) > 2 && parseFloat(lead.rating) < 3 }"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 4 , 'active-half': parseFloat(lead.rating) > 3 && parseFloat(lead.rating) < 4}"></i>
                        <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': parseFloat(lead.rating) >= 5 , 'active-half': parseFloat(lead.rating) > 4 && parseFloat(lead.rating) < 5}"></i>
                      </div>
                      <i class="fa fa-spinner fa-spin qaLoaderIcon" aria-hidden="true" *ngIf="qaLoader == lead.id"></i>
                    </a>
                    <div class="qa-feedback-m">
                      <div class="modal fade" [id]="'qaFeedBack_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2">Q/A Feedback</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body" *ngIf="qaComments.length > 0">
                              <ng-container  *ngFor="let comment of qaComments">
                                <div class="feedback-madal comment-box">
                                  <div class="ratings" *ngIf="comment.qaRating">
                                    <div class="stars">
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 1 , 'active-half': comment.qaRating > 0 && comment.qaRating < 1 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 2 , 'active-half': comment.qaRating > 1 && comment.qaRating < 2 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 3 , 'active-half': comment.qaRating > 2 && comment.qaRating < 3 }"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 4 , 'active-half': comment.qaRating > 3 && comment.qaRating < 4}"></i>
                                      <i class="fa fa-star" aria-hidden="true" [ngClass]="{'active': comment.qaRating >= 5 , 'active-half': comment.qaRating > 4 && comment.qaRating < 5}"></i>
                                    </div>
                                    <span class="rating-points">{{ comment.qaRating }}/5</span>
                                  </div>
                                  <p class="comment-txt" [innerHtml]="comment.notes | safeHtml:'html' "></p>
                                  <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  <p class="qa-name">{{ agentSearch(comment.user_id, qa) }}</p>
                                </div>
                              </ng-container>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="pos-rel">
                    
                    <div *ngIf="!lead.view_agent_comments">-N/A-</div>
                    <a href="javascript:;" (click)="showComments(lead,indx,'Closed-Agent-Comments')" >
                      <svg *ngIf="loader != lead.id" width="25" height="20" viewBox="0 0 25 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.873 0H5.12695C2.29988 0 0 2.23443 0 4.98105V12.6743C0 14.8659 1.48106 16.7747 3.6272 17.3857L6.10332 19.7915C6.24084 19.925 6.427 20 6.62136 20C6.81553 20 7.00188 19.925 7.13921 19.7915L9.41067 17.5845H19.873C22.7001 17.5845 25 15.3501 25 12.6035V4.98105C25 2.23443 22.7001 0 19.873 0ZM23.5352 12.6035C23.5352 14.5653 21.8924 16.1614 19.873 16.1614H9.1074C8.91323 16.1614 8.72688 16.2364 8.58955 16.3698L6.62136 18.282L4.52518 16.2455C4.43115 16.1541 4.31328 16.0893 4.18415 16.0581C2.58312 15.671 1.46484 14.2796 1.46484 12.6743V4.98105C1.46484 3.01921 3.10764 1.42316 5.12695 1.42316H19.873C21.8924 1.42316 23.5352 3.01921 23.5352 4.98105V12.6035Z" [attr.fill]="lead.view_agent_comments ? '#00A5DC' : 'grey'"/>
                        <path d="M17.1506 6.82312H7.84961C7.44506 6.82312 7.11719 7.14185 7.11719 7.5347C7.11719 7.92774 7.44506 8.24628 7.84961 8.24628H17.1506C17.5552 8.24628 17.883 7.92774 17.883 7.5347C17.883 7.14185 17.5552 6.82312 17.1506 6.82312Z" [attr.fill]="lead.view_agent_comments ? '#00A5DC' : 'grey'"/>
                        <path d="M17.1506 9.33826H7.84961C7.44506 9.33826 7.11719 9.6568 7.11719 10.0498C7.11719 10.4429 7.44506 10.7614 7.84961 10.7614H17.1506C17.5552 10.7614 17.883 10.4429 17.883 10.0498C17.883 9.6568 17.5552 9.33826 17.1506 9.33826Z" [attr.fill]="lead.view_agent_comments ? '#00A5DC' : 'grey'"/>
                      </svg>
                      <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="loader == lead.id"></i>
                    </a>
                    <div class="comment-modal-m">
                      <div class="modal fade" [id]="'comment_modal'+indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title w-100" id="exampleModalLabel1" *ngIf="agentComments.length > 0">Agent Comments</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="comments-sub w-100" *ngIf="agentComments.length > 0">
                                <ng-container *ngFor="let comment of agentComments">
                                  <div class="comment-box">
                                    <label *ngIf="agents">{{ agentSearch(comment.user_id, agents) }}</label>
                                    <p>{{ comment.notes }}</p>
                                    <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                                  </div>
                                </ng-container>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </ng-container>

        </table>
      </div>
    </div>
  </div>
</section>
